import { toast } from "sonner"

export function handleCopyClick(text: string) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success("Link copied to clipboard")
    })
    .catch((err) => {
      toast.error("Could not copy text")
    })
}
